<template>
  <div :class="$style.wrapper">
    <div>
      <!-- TOPに戻る -->
      <div :class="$style.pagetop">
        <a
          href="#"
          class="icon-chevronup"
          :class="$style.pagetopArrow"
          @click.prevent="onPageTopClick"
        />
      </div>
      <!-- フッター -->
      <footer :class="$style.footer">
        <div :class="$style.inner">
          <!-- SNS/メディア -->
          <div :class="[$style.footerBox, $style.medialink]">
            <div :class="$style.sns" class="pt-sans">
              <p>VOCE Official Media</p>
              <div :class="$style.snsList">
                <template v-for="sns in snsLinks">
                  <span :key="sns.name">
                    <a
                      :href="sns.link"
                      :class="[$style.icon, sns.icon, $style.snsItem]"
                      target="_blank"
                    />
                  </span>
                </template>
                <span>
                  <a
                    href="https://www.tv-asahi.co.jp/beautv/"
                    :class="$style.beautytv"
                    target="_blank"
                  >
                    <img
                      src="@/assets/img/common/img_footer_beautv.jpg"
                      alt="Beautv Voce"
                      width="91"
                      height="36"
                    />
                  </a>
                </span>
              </div>
            </div>
            <div :class="$style.line">
              <div :class="$style.lineInner">
                <p :class="$style.lineTitle">LINE NEWS</p>
                <p :class="$style.lineText">
                  厳選したビューティ<br />ニュースを週3回配信
                </p>
                <a href="https://line.me/R/ti/p/%40oa-voce">
                  <img
                    src="@/assets/img/common/btn_line.png"
                    alt="友だち追加"
                    width="118"
                    height="30"
                    target="_blank"
                  />
                </a>
              </div>
              <div :class="$style.lineInner">
                <p :class="$style.lineTitle">公式LINEアカウント</p>
                <p :class="$style.lineText">
                  速報を不定期で配信
                </p>
                <a href="https://line.me/R/ti/p/%40jrg8995s">
                  <img
                    src="@/assets/img/common/btn_line.png"
                    alt="友だち追加"
                    width="118"
                    height="30"
                    target="_blank"
                  />
                </a>
              </div>
            </div>
          </div>
          <!-- フッターナビ SP用 -->
          <div :class="[$style.footerBox, $style.navigation]">
            <div :class="$style.footerNav">
              <div
                v-for="link in linkList"
                :key="link.name"
                :class="[
                  $style.footerNavInner,
                  ,
                  { [$style.isSingleLine]: link.isSingleLine },
                ]"
              >
                <p v-if="link.name !== ''" :class="$style.footerNavTitle">
                  <a :href="link.url"
                    ><i class="icon-arrowtrianglerightfill-50" />{{
                      link.name
                    }}</a
                  >
                </p>
                <ul>
                  <li
                    v-for="child in link.child"
                    :key="child.name"
                    :class="{ [$style.isSingleLine]: child.isSingleLine }"
                  >
                    <a :href="child.url"
                      ><i class="icon-arrowtrianglerightfill-50" />{{
                        child.name
                      }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 注釈 -->
          <div :class="[$style.footerBox, $style.note]">
            <div :class="$style.subnavigation">
              <div :class="$style.information1">
                <ul>
                  <li>
                    <a href="https://i-voce.jp/faq/"
                      ><i
                        class="icon-arrowtrianglerightfill-50"
                      />よくある質問</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://i-voce.jp/enquete/?uecfcode=enq-2t4sub-97"
                      target="_blank"
                      ><i
                        class="icon-arrowtrianglerightfill-50"
                      />お問い合わせ</a
                    >
                  </li>
                  <li>
                    <a href="https://i-voce.jp/about/"
                      ><i
                        class="icon-arrowtrianglerightfill-50"
                      />VOCEについて</a
                    >
                  </li>
                </ul>
              </div>
              <div :class="$style.information2">
                <ul>
                  <li>
                    <a
                      href="https://www.kodansha.co.jp/privacy/"
                      target="_blank"
                      ><i class="icon-newwindow" />プライバシーポリシー</a
                    >
                  </li>
                  <li>
                    <a href="https://i-voce.jp/terms/" target="_blank"
                      ><i class="icon-newwindow" />利用規約</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.fujisan.co.jp/product/12804077/"
                      target="_blank"
                      ><i class="icon-newwindow" />定期購読について</a
                    >
                  </li>
                  <li>
                    <a href="https://www.kodansha.co.jp/" target="_blank"
                      ><i class="icon-newwindow" />講談社ホームページ</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://ad.kodansha.net/category/2/"
                      target="_blank"
                      ><i class="icon-newwindow" />広告掲載について</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div :class="$style.abj">
              <a href="https://aebs.or.jp/" target="_blank">
                <img
                  :class="$style.abjImg"
                  src="@/assets/img/common/img_footer_abj.png"
                  alt="ABJ"
                  width="60"
                  height="50"
                />
                <p :class="$style.abjText">
                  ABJマークは、この電子書店・電子書籍配信サービスが、著作権者からコンテンツ使用許諾を得た正規版配信サービスであることを示す登録商標(登録番号
                  第6091713号)です。 詳しくはこちらを御覧ください<br />
                  https://aebs.or.jp/
                </p>
              </a>
            </div>
            <p :class="$style.voce">
              ※VOCE本誌並びにウェブサイト内の商品価格は消費税込みの総額表示ですが、2021年3月31日以前に作成された記事内の商品価格は、作成時の税率もしくは外税で表記しています。
            </p>
          </div>
        </div>
      </footer>
      <!-- 講談社女性誌メディア リンク -->
      <ul :class="$style.magazines">
        <li>
          <a
            href="https://www.vivi.tv/?utm_source=voce&utm_medium=inhouse_link&utm_campaign=inhouse_link"
            target="_blank"
          >
            <img
              src="@/assets/img/common/img_footer_magazine_vivi.png"
              alt="ViVi"
              width="60"
              height="34"
            />
          </a>
        </li>
        <li>
          <a
            href="https://withonline.jp/?utm_source=voce&utm_medium=inhouse_link&utm_campaign=inhouse_link"
            target="_blank"
          >
            <img
              src="@/assets/img/common/img_footer_magazine_with.png"
              alt="with online"
              width="159"
              height="28"
            />
          </a>
        </li>
        <li>
          <a
            href="https://mi-mollet.com/?utm_source=voce&utm_medium=inhouse_link&utm_campaign=inhouse_link"
            target="_blank"
          >
            <img
              src="@/assets/img/common/img_footer_magazine_mi-mollet.png"
              alt="mi-mollet"
              width="120"
              height="34"
            />
          </a>
        </li>
        <li>
          <a
            href="https://gendai.media/frau/?utm_source=voce&utm_medium=inhouse_link&utm_campaign=inhouse_link"
            target="_blank"
          >
            <img
              src="@/assets/img/common/img_footer_magazine_frau.png"
              alt="FRaU"
              width="88"
              height="30"
            />
          </a>
        </li>
      </ul>
      <!-- コピーライト -->
      <div :class="$style.logo">
        <a href="https://www.kodansha.co.jp/" target="_blank"><VcLogoCorp /></a>
      </div>
      <p :class="$style.copyright" class="pt-sans">
        <small>
          COPYRIGHT©{{ getCurrentYear }} KODANSHA LTD. ALL RIGHTS RESERVED.
        </small>
      </p>
    </div>
  </div>
</template>

<script>
  import snsLinks from "@/util/snsLinks";
  import VcLogoCorp from "./VcLogoCorp.vue";

  export default {
    components: {
      VcLogoCorp,
    },
    data() {
      return {
        snsLinks,
        linkList: [
          {
            name: "記事を見る",
            url: "https://i-voce.jp/feed/",
            child: [
              {
                name: "メイクアップ",
                url: "https://i-voce.jp/make-up/",
              },
              {
                name: "ライフスタイル",
                url: "https://i-voce.jp/lifestyle/",
              },
              {
                name: "スキンケア",
                url: "https://i-voce.jp/skincare/",
              },
              {
                name: "占い・診断",
                url: "https://i-voce.jp/fortune/",
              },
              {
                name: "ヘア&ネイル",
                url: "https://i-voce.jp/hair-nail/",
              },
              {
                name: "連載・シリーズ",
                url: "https://i-voce.jp/serial-stories/",
              },
              {
                name: "ボディケア",
                url: "https://i-voce.jp/bodycare/",
              },
              {
                name: "VOCE LAB.",
                url: "https://i-voce.jp/vocelab/",
              },
            ],
          },
          {
            name: "コスメ",
            url: "https://i-voce.jp/cosmetics/",
            child: [
              {
                name: "2025年上半期ベストコスメ",
                url: "https://i-voce.jp/bestcosme/",
                isSingleLine: true,
              },
              {
                name: "秋コスメ特集【2025最新】",
                url: "https://i-voce.jp/special/autumnnewcolor/",
              },
              {
                name: "夏コスメ特集【2025最新】",
                url: "https://i-voce.jp/special/summernewcolor/",
              },
              {
                name: "メンズコスメ特集",
                url: "https://sp.i-voce.jp/special/mensbestcosme/",
                isSingleLine: true,
              },
              {
                name: "コスメ発売日カレンダー",
                url: `https://i-voce.jp/cosmetics/calendar/weekly/${new Date().getFullYear()}${(
                  "0" +
                  (new Date().getMonth() + 1)
                ).substr(-2)}/`,
              },
              {
                name: "プロの目",
                url: "https://i-voce.jp/cosmetics/professional-reviews/",
              },
            ],
          },
          {
            name: "ランキング",
            url: "https://i-voce.jp/ranking/",
            child: [
              {
                name: "記事ランキング",
                url: "https://i-voce.jp/ranking/article/",
              },
              {
                name: "コスメランキング",
                url: "https://i-voce.jp/ranking/cosmetics/",
              },
            ],
          },
          {
            name: "",
            isSingleLine: true,
            child: [
              {
                name: "美容のプロ",
                url: "https://i-voce.jp/professionals/",
              },
              {
                name: "ビューティ動画",
                url: "https://i-voce.jp/videos/",
              },
              {
                name: "プレゼント",
                url: "https://i-voce.jp/presents/",
              },
              {
                name: "VOCE最新号",
                url: "https://i-voce.jp/latest-issue/",
              },
            ],
          },
        ],
      };
    },
    computed: {
      getCurrentYear() {
        const currentYear = new Date().getFullYear();
        return currentYear;
      },
    },
    methods: {
      onPageTopClick() {
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      },
    },
  };
</script>

<style module>
  .wrapper {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-top: 60px;
    background: #fff;
    color: rgba(17, 17, 17, 0.33);
  }
  .pagetop {
    position: relative;
    width: 100%;
    height: 50px;
  }
  .pagetopArrow {
    position: absolute;
    bottom: -3px;
    left: 50%;
    right: 50%;
    margin-left: -33px;
    box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.16);
    color: rgba(17, 17, 17, 0.33);
    width: 65px;
    height: 35px;
    line-height: 55px;
    border-radius: 100px 100px 0 0;
    background: #fff;
    text-align: center;
    font-size: 30px;
    cursor: pointer;
  }
  .pagetopArrow::after {
    content: "";
    display: block;
    width: 65px;
    height: 10px;
    background-color: #fff;
    position: absolute;
    bottom: -8px;
    left: 0;
  }
  .footer {
    padding: 1px 10px 23px;
    margin: 0 auto;
    box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.16),
      0px 1px 2px rgba(0, 0, 0, 0.16);
  }
  .footerNav {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  .footerNavInner {
    width: 100%;
    margin-bottom: 20px;
  }
  .footerNavTitle {
    border-bottom: 1px solid rgba(51, 51, 51, 0.08);
    text-align: center;
    padding-bottom: 5px;
  }
  .footerNavTitle a {
    font-weight: bold;
    font-size: 15px;
    line-height: 132%;
    color: rgba(17, 17, 17, 0.33);
  }
  .footerNavInner ul {
    margin: 0 auto;
    max-width: 368px;
    padding: 6px 24px 0;
    display: flex;
    flex-wrap: wrap;
  }
  .footerNavInner li {
    flex: 0 1 auto;
    min-width: 50%;
    line-height: 120%;
  }
  .footerNavInner li a {
    font-weight: bold;
    font-size: 14px;
    letter-spacing: 0.02em;
    color: rgba(17, 17, 17, 0.33);
    display: block;
    padding: 6px 0;
  }
  .footerNavInner li a::before {
    color: #b3b3b8;
  }
  .footerNavInner.isSingleLine li,
  .footerNavInner li.isSingleLine {
    width: 100%;
  }
  .footerBox {
    margin: 0 auto;
  }
  .navigation {
    margin: 35px -10px 0;
  }
  .note {
    padding: 0 14px;
  }
  .sns {
    text-align: center;
    margin: 40px 0 25px 0;
  }
  .media {
    text-align: center;
    margin: 0 0 27px 0;
  }
  .snsList {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  .snsList a {
    display: block;
    text-align: center;
    text-indent: -3px;
  }
  .snsItem {
    width: 40px;
  }
  .beautytv {
    width: 90px;
    margin-left: 13px;
  }
  .line {
    display: flex;
    margin-top: 30px;
    justify-content: center;
  }
  .lineInner {
    margin: 0 4%;
    text-align: center;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    align-items: center;
    max-width: 150px;
  }
  .lineTitle {
    font-weight: bold;
    font-size: 15px;
    line-height: 132%;
    color: rgba(17, 17, 17, 0.54);
  }
  .lineText {
    font-size: 12px;
    line-height: 125%;
    text-align: center;
    letter-spacing: -0.04em;
    color: rgba(17, 17, 17, 0.54);
    flex-grow: 1;
    margin: 7px 0 8px;
    width: 118px;
  }
  .mailmagazine {
    margin-top: 32px;
  }
  .mailmagazineTitle {
    text-align: center;
  }
  .mailmagazine a {
    background: #e4007f;
    box-shadow: 0px 6px 12px rgba(228, 0, 127, 0.33);
    border-radius: 4px;
    color: #ffffff;
    width: 200px;
    height: 48px;
    letter-spacing: -0.02em;
    margin: 13px auto 0;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .mailmagazine span {
    font-size: 16px;
    line-height: 100%;
    font-weight: bold;
  }
  .mailmagazine a::before {
    font-size: 32px;
    display: block;
    font-weight: normal;
    line-height: 1;
    margin-right: 8px;
  }
  .icon {
    color: rgba(17, 17, 17, 0.33);
    font-size: 46px;
    line-height: 46px;
    letter-spacing: -6px;
  }
  .mediaList {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    max-width: 262px;
  }
  .mediaList a {
    display: block;
  }
  .mediaList img {
    margin: 17px 0 0;
  }
  .subnavigation {
    display: flex;
    flex-wrap: wrap;
    margin: 52px auto 0;
    max-width: 320px;
  }
  .information1 a {
    font-weight: bold;
    font-size: 14px;
    color: rgba(17, 17, 17, 0.33);
    letter-spacing: -0.02em;
  }
  .information1 a::before {
    color: rgba(17, 17, 17, 0.33);
  }
  .information1 li {
    margin-bottom: 5px;
    width: 132px;
    margin-right: 10px;
  }
  .information2 a::before {
    color: rgba(17, 17, 17, 0.33);
  }
  .information2 a {
    font-size: 14px;
    color: rgba(17, 17, 17, 0.33);
    letter-spacing: -0.02em;
  }
  .information2 li {
    margin-bottom: 5px;
  }
  .information2 ul:nth-child(2) {
    margin-top: 15px;
  }
  .information2 a::before {
    font-size: 19px;
    vertical-align: middle;
  }
  .abj {
    display: flex;
    font-size: 12px;
    width: 100%;
    padding-top: 17px;
  }
  .abjImg {
    float: left;
    margin-right: 9px;
  }
  .abjText {
    font-size: 10px;
    line-height: 120%;
    letter-spacing: -0.04em;
    margin: 0 auto;
    color: rgba(17, 17, 17, 0.33);
  }
  .abjText a {
    color: rgba(17, 17, 17, 0.33);
  }
  .voce {
    font-size: 12px;
    margin: 0 auto;
    color: rgba(17, 17, 17, 0.33);
    padding-top: 20px;
    line-height: 125%;
    letter-spacing: -0.04em;
  }
  .logo {
    margin: 16px 0;
  }
  .logo svg {
    display: block;
    width: 155px;
    margin: 0 auto;
  }
  .copyright small {
    font-size: inherit;
  }
  .copyright {
    text-align: center;
    margin: 26px 0 29px 0;
    color: rgba(17, 17, 17, 0.33);
    font-size: 12px;
    line-height: 1.25;
    letter-spacing: -0.04em;
  }
  .isPc {
    display: none;
  }
  .idLounge {
    display: none;
  }
  .magazines {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    box-shadow: inset 0px 1px 2px rgba(245, 221, 221, 0.16),
      0px 1px 2px rgba(0, 0, 0, 0.16);
    padding: 16px 10px;
  }
  .magazines li {
    margin: 9px 10px;
  }
  /* PC */
  @media screen and (min-width: 769px) {
    .pagetopArrow {
      margin-left: -39px;
      width: 77px;
      height: 44px;
      line-height: 73px;
    }
    .pagetopArrow::after {
      width: 77px;
    }
    .footer {
      padding: 0 16px 35px;
    }
    .inner {
      margin: 0 auto;
      max-width: 1260px;
      display: flex;
      justify-content: space-between;
    }
    .footerBox {
      margin: 40px 0 0;
      padding: 5px 0 10px 0;
    }
    .medialink {
      width: 26%;
    }
    .navigation {
      width: 47%;
      margin: 20px 0 0;
    }
    .subnavigation {
      max-width: inherit;
      margin-top: 0;
    }
    .footerNavInner {
      min-width: 290px;
      width: 49%;
    }
    .footerNavImknner ul {
      padding: -10px 0 0 16px;
    }
    .footerNavInner .footerNavTitle + ul {
      padding: 10px 0 0 16px;
    }
    .information1 {
      width: 45%;
      min-width: 132px;
    }
    .information2 {
      width: 55%;
      min-width: 155px;
    }
    .note {
      width: 25%;
    }
    .sns {
      margin: 0 auto;
      padding: 0;
    }
    .media {
      text-align: center;
      margin: 0 auto;
      padding-top: 28px;
      max-width: 262px;
    }
    .mediaList img {
      margin: 20px 0 0 0;
    }
    /* TODO:9/19分調整 */
    /* .information a:nth-last-child(2) { */
    .information a:nth-last-child(2),
    .information a:last-child {
      border-bottom: 1px solid #dddddd;
    }

    .abj {
      margin: auto;
      padding: 3px 0 0 0;
    }
    .abjText {
      font-size: 12px;
      line-height: 125%;
    }
    .voce {
      padding: 30px 0 0 0;
    }
    .logo {
      margin: 24px 0;
    }
    .logo svg {
      width: 182px;
    }
    .copyright {
      margin: 10px 0 29px 0;
    }
    .isSp {
      display: none;
    }
    .magazines {
      height: 80px;
      padding: 0;
    }
    .magazines li {
      margin: 0 36px;
    }
  }
  @media screen and (min-width: 769px) and (max-width: 1380px) {
    .medialink {
      width: 45%;
    }
    .subnavigation {
      flex-flow: column;
      align-items: center;
    }
    .navigation {
      width: 55%;
    }
    .inner {
      flex-wrap: wrap;
    }
    .note {
      width: 100%;
      padding: 0 16px;
    }
    .information1,
    .information2 {
      width: auto;
      min-width: inherit;
    }
    .information1 ul,
    .information2 ul {
      display: flex;
    }
    .information2 li {
      margin-right: 10px;
    }
    .information2 ul:nth-child(2) {
      margin-top: 0;
    }
    .abj {
      padding-top: 17px;
    }
  }
</style>
